import { useState, useCallback } from 'react'
import PropTypes from 'prop-types'
import { Button, Menu, MenuItem } from '@mui/material'

import { ReactComponent as Sliders } from '../../../assets/icons/sliders.svg'
import { ReactComponent as Pdf } from '../../../assets/icons/file-pdf.svg'
import Checkbox from '../../../ui/components/checkbox'
import useTranslations from '../../../i18n/useTranslations'

import styles from './styles'
import useStatusCodeFilterOptions from '../useStatusCodeFilterOptions'
import { useIncidentCodeFilterOptions } from '../useIncidentCodeFilterOptions'

function StatusCodeQuickFiltersView({
  isOptionChecked,
  disabledFilterByStatusCode,
  disabledGenerateManifest,
  updateOption,
  selectedTracking,
  onGenerateManifestClick,
}) {
  const t = useTranslations()

  const [anchorEl, setAnchorEl] = useState(null)

  const handleOpenClick = useCallback(event => {
    setAnchorEl(event.currentTarget)
  }, [])

  const handleClose = useCallback(() => {
    setAnchorEl(null)
  }, [])

  const isMenuOpen = Boolean(anchorEl)

  const optionsStatus = useStatusCodeFilterOptions(isOptionChecked)
  const optionsIncidents = useIncidentCodeFilterOptions(isOptionChecked)
  const options =
    selectedTracking === 'incidents' ? optionsIncidents : optionsStatus
  return (
    <>
      <div style={styles.buttonContainer}>
        <Button
          onClick={onGenerateManifestClick}
          variant="text"
          size="small"
          startIcon={<Pdf />}
          sx={styles.button}
          disabled={disabledGenerateManifest}
        >
          {t('noun:generate-manifest')}
        </Button>
        <Button
          onClick={handleOpenClick}
          variant="text"
          size="small"
          startIcon={<Sliders />}
          sx={{
            ...styles.button,
            marginLeft: '0 !important',
          }}
          disabled={disabledFilterByStatusCode}
        >
          {selectedTracking === 'incidents'
            ? t('noun:incident-filters')
            : t('noun:state-filters')}
        </Button>
      </div>
      <Menu
        anchorEl={anchorEl}
        open={isMenuOpen}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        sx={styles.statesMenu}
      >
        {options.map(checkedStatus => (
          <MenuItem key={checkedStatus.id} value={checkedStatus.label}>
            <Checkbox
              name={checkedStatus.id}
              label={checkedStatus.label}
              checked={checkedStatus.checked}
              onChange={() => {
                updateOption(checkedStatus)
              }}
            />
          </MenuItem>
        ))}
      </Menu>
    </>
  )
}

StatusCodeQuickFiltersView.propTypes = {
  isOptionChecked: PropTypes.func.isRequired,
  selectedTracking: PropTypes.string,
  disabledFilterByStatusCode: PropTypes.bool,
  disabledGenerateManifest: PropTypes.bool,
  updateOption: PropTypes.func.isRequired,
  onGenerateManifestClick: PropTypes.func.isRequired,
}

export default StatusCodeQuickFiltersView
